import React from 'react';
import { useParams, Link } from 'react-router-dom';
import comProducts from '../Shared/comProducts';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

function CommunicationDetail() {
  const { id } = useParams();
  const product = comProducts.find(p => p.id === parseInt(id));

  if (!product) {
    return (
      <div className="pt-20 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-marine-black mb-4">Product not found</h2>
          <Link to="/products/communication" className="text-marine-red hover:text-red-700">
            Back to Communication Products
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="pt-20 font-tt-lakes">
      
      <div className="bg-gray-50 border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <Link 
            to="/products/communication"
            className="inline-flex items-center text-marine-red hover:text-red-700 transition-colors duration-300"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-2" />
            Back to Communication Products
          </Link>
        </div>
      </div>

      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
         
          <div className="rounded-xl overflow-hidden shadow-lg">
            <img
              src={product.image}
              alt={product.name}
              className="w-full h-[400px] object-cover"
            />
          </div>

          
          <div className="space-y-8">
            <div>
              <h1 className="text-4xl font-bold text-marine-black mb-4">
                {product.name}
              </h1>
              <p className="text-xl text-gray-600">
                {product.description}
              </p>
            </div>

           
            <div>
              <h2 className="text-2xl font-bold text-marine-black mb-4">
                Key Features
              </h2>
              <ul className="space-y-4">
                {product.features.map((feature, index) => (
                  <li key={index} className="flex items-start">
                    <svg 
                      className="h-6 w-6 text-marine-red mr-3 mt-0.5" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M5 13l4 4L19 7" 
                      />
                    </svg>
                    <span className="text-lg text-gray-600">{feature}</span>
                  </li>
                ))}
              </ul>
            </div>

            
            <div>
              <h2 className="text-2xl font-bold text-marine-black mb-4">
                Technical Specifications
              </h2>
              <div className="bg-gray-50 rounded-xl p-6">
                <dl className="space-y-4">
                  {product.specifications.map((spec, index) => (
                    <div key={index} className="grid grid-cols-3 gap-4">
                      <dt className="text-gray-600 font-medium">{spec.name}</dt>
                      <dd className="text-marine-black col-span-2">{spec.value}</dd>
                    </div>
                  ))}
                </dl>
              </div>
            </div>

           
            <button className="w-full bg-marine-red hover:bg-red-700 text-white px-8 py-4 rounded-xl text-lg font-medium transition-colors duration-300">
              Request More Information
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommunicationDetail;